import React from 'react';
import '../styles/Flags.css';

function Flags(props) {
    const label = props.label;
    const data = props.data;
    return (
        <div className="flags-outer-container">
            <span className="body-regular colour-secondary">
                {label}
            </span>
            <ul className="flags-body-container">
                {
                    data.map((item, index) =>
                        <li 
                            className="body-regular colour-primary"
                            key={index}
                        >
                            {item}
                        </li>
                    )
                }
            </ul>
        </div>
    )
};

export default Flags;